import { isArray } from "lodash"
import { Requests } from "./Requests"

export default class OrganizationAPI {

  /**
   * Fetch all organizations
   * @returns {Array<Object>}
   */
  static async fetchAllOrganizations(endpoint){
    const url = `${endpoint}/api/organization`
    const organizations = await Requests.authRequest(url, 'GET')
    return (organizations === undefined || !isArray(organizations)) ? [] : organizations
  }

  /**
   * Fetch an organization by id
   * @param {Number|String} id
   * @returns {Object}
   */
  static async fetchOrganization(endpoint, id){
    const url = `${endpoint}/api/organization/${id}`
    return Requests.authRequest(url, "GET")
  }

  /**
   * Creates an organization using the API directly
   * @param {Object} orgData - Organization data object
   * @param {string} orgData.organizationName - Name of the organization
   * @param {string} orgData.identityProvider - Authentication type (MARLEY or FEDERATED)
   * @param {string} [orgData.domainName] - Domain name for FEDERATED auth
   * @param {boolean} [orgData.createSupportUser=false] - Whether to create a support user for the organization
   * @param {Object} [orgData.integration] - Integration configuration
   * @param {string} [orgData.integration.authentication] - Authentication method (KEY or OAUTH2)
   * @returns {Promise<Object>} The created organization object
   */
  static async createOrganizationRequest(body, endpoint) {
    const url = `${endpoint}/api/toolkit/organization`;
    return Requests.authRequest(url, 'POST', body, true);
  }

  // Utility function to extract and normalize domain from email
  static getNormalizedDomainMarleyUser = (input) => {
    if (!input || typeof input !== 'string') return null;
    
    // extract the domain
    let domain = input.includes('@') ? input.split('@')[1] : input;
    
    // Normalize the domain (lowercase, remove www)
    return domain.toLowerCase().replace(/^www\./, '');
  }
}